module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-384x384-0814ce0fd8cede4c5986e1c5b1a2d667.png";